import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import userAPI from "../../api/UserApi";
import { clearAccessToken } from "../../api/axiosInstance";
import { LayoutDashboard, ShoppingBag, MapPin, User, Key, LogOut } from "lucide-react"; // 🌟 Added studio mini vector icons

function Sidebar() {
  const navigate = useNavigate();

 const logOut = async (e) => {
  if (e) e.preventDefault(); // Loop rules anchor safe triggers
  
  try {
    // 1. Phle backend ko update bhejte hain logout ka
    await userAPI.logOut();
  } catch (err) {
    // 🌟 API FAIL-SAFE LAYER: Agar backend fail bhi ho jaye, toh console print karo aur rukna nahi hai!
    console.log("Backend logout bypass operational:", err);
  } finally {
    // 2. 🌟 GUARANTEED CLEARANCE: Yeh block har haal mein chalega chahe try pass ho ya catch fail!
    clearAccessToken();
    localStorage.removeItem("token");
    localStorage.removeItem("accessToken");
    
    // 3. Clear all states and push back directly to landing matrix root
    navigate("/");
    
    // 4. Force hard reload mirror window taaki header aur baki states instantly sync lock ho jayein
    window.location.reload();
  }
};

  return (
    <div className="orangeapes-profile-sidebar p-3 p-md-4">
      <div className="orangeapes-profile-nav-links-stack">
        
        <div className="orangeapes-nav-item-wrapper">
          <NavLink
            to="/users/dashboard"
            className={({ isActive }) =>
              `orangeapes-sidebar-link ${isActive ? "orangeapes-link-active" : ""}`
            }
          >
            <LayoutDashboard size={16} className="sidebar-vector-icon" />
            <span>Dashboard</span>
          </NavLink>
        </div>

        <div className="orangeapes-nav-item-wrapper">
          <NavLink
            to="/users/orders"
            className={({ isActive }) =>
              `orangeapes-sidebar-link ${isActive ? "orangeapes-link-active" : ""}`
            }
          >
            <ShoppingBag size={16} className="sidebar-vector-icon" />
            <span>My Orders</span>
          </NavLink>
        </div>

        <div className="orangeapes-nav-item-wrapper">
          <NavLink
            to="/users/addresses"
            className={({ isActive }) =>
              `orangeapes-sidebar-link ${isActive ? "orangeapes-link-active" : ""}`
            }
          >
            <MapPin size={16} className="sidebar-vector-icon" />
            <span>Addresses</span>
          </NavLink>
        </div>

        <div className="orangeapes-nav-item-wrapper">
          <NavLink
            to="/users/account"
            className={({ isActive }) =>
              `orangeapes-sidebar-link ${isActive ? "orangeapes-link-active" : ""}`
            }
          >
            <User size={16} className="sidebar-vector-icon" />
            <span>Account Details</span>
          </NavLink>
        </div>

        <div className="orangeapes-nav-item-wrapper">
          <NavLink
            to="/users/change-password"
            className={({ isActive }) =>
              `orangeapes-sidebar-link ${isActive ? "orangeapes-link-active" : ""}`
            }
          >
            <Key size={16} className="sidebar-vector-icon" />
            <span>Change Password</span>
          </NavLink>
        </div>

        <div className="orangeapes-nav-item-wrapper orangeapes-logout-border-top pt-2 mt-2">
          <a
            href="#logout"
            onClick={logOut}
            className="orangeapes-sidebar-link orangeapes-logout-trigger-btn"
          >
            <LogOut size={16} className="sidebar-vector-icon text-danger-token" />
            <span>Logout</span>
          </a>
        </div>

      </div>
    </div>
  );
}

export default Sidebar; 